<template>
  <nav>

  </nav>
  <div>
    <router-view />
  </div>
  <web-socket></web-socket>
</template>
<script setup>

// 解决ERROR ResizeObserver loop completed with undelivered notifications.

//问题的



import { provide, nextTick, ref, onMounted } from 'vue'
import api from './api/api';
import { ElMessage, ElMessageBox } from 'element-plus'
import { useRouter } from 'vue-router';

const router = useRouter()

onMounted(() => {
  sessionStorage.setItem('relogin', true)
  messlist()
  test()
})
let messlist = ()=>{
  let messages = localStorage.getItem('message')
  console.log('messages',messages)
  if(messages == null){
    let message = {
      orderMsg: [],
      integralOrderMsg: [],
      seckillActivityMsg: [],
    }
    localStorage.setItem('message',JSON.stringify(message) )
  }
}

let isRouterActive = ref(true)

provide('reload', () => {
  isRouterActive.value = false
  nextTick(() => {
    isRouterActive.value = true
  })
})

const test = async () => {
  const res = await api.test()
  if (res.code == 401) {
    ElMessageBox.alert('登录已过期请重新登入！', '', {

      confirmButtonText: 'OK',
      callback: (action) => {
        router.push({
          path: '/login'
        })
      }
    })

  }
}

const debounce = (fn, delay) => {

  let timer = null;

  return function () {

    let context = this;

    let args = arguments;

    clearTimeout(timer);

    timer = setTimeout(function () {

      fn.apply(context, args);

    }, delay);

  }

}

// 解决ERROR ResizeObserver loop completed with undelivered notifications.

//问题的

const _ResizeObserver = window.ResizeObserver;

window.ResizeObserver = class ResizeObserver extends _ResizeObserver {

  constructor(callback) {

    callback = debounce(callback, 16);

    super(callback);

  }

}

</script>
<style lang="scss">
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

input {
  padding-left: 12px;
  font-size: 16px;
  color: #111827;
  outline: none;
  background: transparent;
  border: none;
  outline: medium;
  width: 100%;
}

ol,
ul {
  list-style: none;
}

body {
  font-family: 'Microsoft YaHei', Arial, Helvetica, sans-serif;
}
</style>
